import {combineReducers} from 'redux'
import AuthR from './AuthR'
import QuarterR from './QuarterR'


const RootR = combineReducers({
  AuthR,
  QuarterR
})

export default RootR;
